/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_st_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are these F1 Fantasy points or real championship points?`)
};

const es_f1_st_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estos son puntos de F1 Fantasy o puntos reales del campeonato?`)
};

const de_f1_st_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind das F1-Fantasy-Punkte oder echte Meisterschaftspunkte?`)
};

const nl_f1_st_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zijn dit F1 Fantasy-punten of echte kampioenschapspunten?`)
};

const fr_f1_st_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S'agit-il de points F1 Fantasy ou de vrais points de championnat ?`)
};

const it_f1_st_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questi sono punti F1 Fantasy o punti reali del campionato?`)
};

const pt_br2_f1_st_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esses são pontos de F1 Fantasy ou pontos reais do campeonato?`)
};

const pt_f1_st_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estes são pontos de F1 Fantasy ou pontos reais do campeonato?`)
};

const ja_f1_st_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これはF1ファンタジーポイントですか、それとも実際の選手権ポイントですか？`)
};

const zh_f1_st_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是F1梦幻积分还是真实的锦标赛积分？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_st_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_st_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_st_faq1_q", locale)
	if (locale === "en") return en_f1_st_faq1_q(inputs)
	if (locale === "es") return es_f1_st_faq1_q(inputs)
	if (locale === "de") return de_f1_st_faq1_q(inputs)
	if (locale === "nl") return nl_f1_st_faq1_q(inputs)
	if (locale === "fr") return fr_f1_st_faq1_q(inputs)
	if (locale === "it") return it_f1_st_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_st_faq1_q(inputs)
	if (locale === "pt") return pt_f1_st_faq1_q(inputs)
	if (locale === "ja") return ja_f1_st_faq1_q(inputs)
	return zh_f1_st_faq1_q(inputs)
};